<template>
    <div class="box-offset">
        <div class="calendar-holder">
            <div class="row">
                <div class="col-12">
                    <label for="start" class="form-label">Duration:</label>
                    <div class="form-group">
                        <select id="duration" class="custom-select" v-model="duration">
                            <option
                                v-for="(item, index) in durations"
                                :value="item.value"
                                :key="index"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="calendar-holder mb-4">
                <date-picker
                    inline
                    @calendar-change="onMonthChange"
                    :disabled-date="isDisabledDate"
                    v-model="calendar"
                ></date-picker>
            </div>

            <div class="row">
                <div class="col-12">
                    <label for="start" class="form-label">Starts:</label>
                    <div class="form-group">
                        <select id="start" class="custom-select" v-model="starts">
                            <option
                                :disabled="isNotAllowedTime(time)"
                                v-for="(time, index) in availableTimeRange"
                                :value="time"
                                :key="index"
                            >
                                {{ timeFormatFullToHalf(time) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="separation"></div>
        </div>

        <div class="total-cost">
            <div class="row">
                <div class="col-6 ">
                    <p>Booking cost:</p>
                </div>
                <div class="col-6 text-right">
                    <p>
                        <strong>
                            {{ bookingCost | toFixed | toUSD }}
                        </strong>
                    </p>
                </div>
            </div>
        </div>

        <a :href="bookingUrl" class="btn w-100">
            Book now
        </a>

        <div class="d-flex mt-4">
            <span class="mr-2">*</span>
            <p>
                For <strong>Sunset 2 hour</strong> Tour contact reservations
                <a href="tel:954.997.6898"><strong class="phone__number">954.997.6898</strong></a>
            </p>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { BoatService } from "@/js/services";

    export default {
        components: { DatePicker },
        props: {
            boat: Object,
            startDayHour: Number,
            endDayHour: Number,
        },
        mounted() {
            this.setDuration();
            // this.getDisableDatesAndTime();
        },
        data() {
            return {
                calendar: new Date(),
                starts: this.startDayHour,
                duration: 4,
                currentPeriodStart: this.getFirstMonthDay(new Date()),
                currentPeriodEnd: this.getLastMonthDay(new Date()),
                disabledDatesArray: [],
                disableTimesArray: [],
                durations: [
                    {
                        value: 4,
                        name: '4h',
                    },
                    {
                        value: 6,
                        name: '6h',
                    },
                    {
                        value: 8,
                        name: '8h',
                    }
                ],
            };
        },
        watch: {
            duration(newDuration) {
                this.updateDurationQuery(newDuration);
                // this.getDisableDates(this.currentPeriodStart, this.currentPeriodEnd)
                // this.calendar = new Date();
                // this.startTimes = this.range(this.startDayHour, (this.endDayHour - newDuration));
            },
            calendar(newValue) {
                // const date = new Date(newValue).toLocaleDateString("en-US", {year:"numeric",month:"2-digit", day:"2-digit"})
                // const selectedTimeRange = this.disableTimesArray[date];
                //
                // if (selectedTimeRange) {
                //     this.startTimes = selectedTimeRange;
                // } else {
                //     this.startTimes = this.range(this.startDayHour, (this.endDayHour - (this.duration)));
                // }
            },
        },
        computed: {
            availableTimeRange() {
                const availableHours = [];

                for (let hour = this.startDayHour; hour <= this.endDayHour; hour++) {
                    availableHours.push(hour);
                }

                return availableHours;
            },
            bookingCost() {
                return this.boat[`price_${this.duration}h`]
            },
            bookingUrl() {
                const [, month, day, year] = this.calendar ? this.calendar.toString().split(' ') : new Date()
                const startDate = new Date(`${month} ${day} ${year} ${this.starts}:00:00`).toLocaleString();

                const queries = {
                    product_id: this.boat.id,
                    starts_at: startDate,
                    duration: this.duration,
                }

                const queryString = Object.keys(queries)
                    .map((key) => `${key}=${encodeURIComponent(queries[key])}`)
                    .join('&');

                return `/products/booking?${queryString}`
            },
            isSameDate() {
                const selectedDate = new Date(this.calendar);
                const today = new Date();

                const providedDate = `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`;
                const todayDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

                return providedDate === todayDate;
            }
        },
        methods: {
            async getDisableDatesAndTime() {
                try {
                    const payload = {
                        duration: this.duration,
                        start: this.currentPeriodStart,
                        end: this.currentPeriodEnd
                    }

                    const queryString = Object.keys(payload)
                        .map((key) => `${key}=${encodeURIComponent(payload[key])}`)
                        .join('&');

                    const { data: { dates, periods } } = await BoatService.getDisabledDates(this.boat.id, queryString);

                    this.disabledDatesArray = dates;
                    this.disableTimesArray = periods;
                } catch (e) {
                    throw new Error(e);
                }
            },
            getFirstMonthDay(date) {
                return new Date(date.getFullYear(), date.getMonth(), 1)
                    .toLocaleDateString('en-US');
            },
            getLastMonthDay(date) {
                return new Date(date.getFullYear(), date.getMonth() + 1, 0)
                    .toLocaleDateString('en-US');
            },
            isDisabledDate(date) {
                return !this.duration ||
                    date < new Date() ||
                    this.disabledDatesArray.includes(date.toLocaleDateString("en-US", { year: "numeric",month: "2-digit", day: "2-digit" }));
            },
            isTimeBooked(index) {
                const selectedTimeIndex = this.availableTimeRange.indexOf(this.starts);

                return (
                    index === selectedTimeIndex ||
                    (index > selectedTimeIndex && index <= +this.duration + selectedTimeIndex)
                );
            },
            isNotAllowedTime(time) {
                const selectedEndTime = +this.duration + time;
                const now = new Date().getHours();

                return selectedEndTime > this.endDayHour || (this.isSameDate && now + 1 >= time);
            },
            onMonthChange(date) {
                const start = this.getFirstMonthDay(date);
                const end = this.getLastMonthDay(date);

                this.currentPeriodStart = start;
                this.currentPeriodEnd = end;
                // this.getDisableDatesAndTime(start, end)
            },
            timeFormatFullToHalf(time) {
                if (time === 12) {
                    return `12:00 pm`;
                } else if (time > 12) {
                    return `${time - 12}:00 pm`;
                } else {
                    return `${time}:00 am`;
                }
            },
            setDuration() {
                this.duration = new URLSearchParams(window.location.search).get('hours') ?? 4;
            },
            updateDurationQuery(duration) {
                const currentUrl = new URL(window.location.href);

                currentUrl.searchParams.set('hours', duration);

                window.history.pushState({}, '', currentUrl.toString());
            }
        },
    };
</script>

<style>
    .mx-calendar {
        width: 100% !important;
        min-width: 250px !important;
        height: 360px !important;
    }

    .mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {
        background-color: #8ccfd2 !important;
        color: #ffffff !important;
    }
    .mx-calendar-content .cell.active {
        background-color: #5ec5c7 !important;
    }

    .mx-calendar-header, .mx-time-header {
        background: #158898 !important;
    }
    .mx-btn-text {
        color: #ffffff !important;
    }

    .mx-table-date .today {
        background-color: #158898 !important;
        color: #ffffff !important;
    }

    .phone__number:hover {
        text-decoration: underline;
    }

    .highlighted {
        background-color: #87ceeb;
        color: #ffffff;
    }
    .mx-btn:focus {
        outline: none;
    }
    .mx-icon-left:before, .mx-icon-right:before, .mx-icon-double-left:before, .mx-icon-double-right:before, .mx-icon-double-left:after, .mx-icon-double-right:after {
        border-color: #fff;
    }

    /*option.time-booked:hover {
        background: #158898;
    }*/

    option:disabled {
        color: #999;
        background-color: #eee;
        cursor: not-allowed;
    }
</style>


